import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "@/utils/cognitoUrlConfig";

interface File {
  name: string;
  url: string;
  signed: boolean;
}

interface AgreementResponse {
  files: Array<File>;
}

class AgreementService {
  client: AxiosInstance;

  constructor(jwt: string) {
    this.client = axios.create({
      baseURL: config.apiURL,
      withCredentials: false,
      headers: {
        Authorization: jwt
      }
    });
  }
  async getAgreement(): Promise<AxiosResponse<AgreementResponse>> {
    return await this.client.get("/agreements");
  }
}

export default AgreementService;
